export default "__VITE_ASSET__C94tvLNy__"